import React from "react";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import FilingForm from "../../../common/form/filing/FilingForm";

const SERecognitionStepFiling = () => {
  const seRecognitionForm = useAppSelector((state) => {
    return state.Forms.SERecognitionForm;
  });

  return (
    <FilingForm
      basePath={baseEndpointPaths.seRecognition}
      appId={seRecognitionForm.id}
      redirectPath={"/se-application"}
      allowedFileApplicationAction={false}
    />
  );
};
export default SERecognitionStepFiling;
